import React from "react";
import { FontAwesome } from "../../FontAwesome";
import { IFlexProps } from "../../Flex";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  containerProps?: IFlexProps;
}

// == Constants ============================================================

const DEFAULT_PROPS = {};

// == Component ============================================================

const Heart = ({ containerProps, ...rest }: IProps) => {
  return (
    <FontAwesome
      containerProps={containerProps}
      data-testid="heart"
      icon={["fas", "heart"]}
      {...rest}
    />
  );
};

Heart.defaultProps = DEFAULT_PROPS;

export default Heart;
// == Styles ===============================================================
